import { useMutation } from '@tanstack/react-query';
import { DataObjectFormDataType, DataObjectType } from '../types';
import { apiClient, ApiErrorResponse } from '../../common/ApiClient';
import { DataObjectDescriptionVersionUrl } from './DataObjectDescriptionVersionUrl';
import { RcFile } from 'antd/es/upload';
import { DataObjectFormDataSchema } from '../schema';
import { expand } from 'uri-template-lite';

interface IArgs {
  file: string | Blob | RcFile;
  id?: number;
  expectedType: DataObjectType;
}

export const useMutateDataObjectUpload = (
  onProgress?: (progress: number) => void,
) =>
  useMutation<Partial<DataObjectFormDataType>, ApiErrorResponse, IArgs>({
    mutationKey: ['dataObjectVersionUpload'],
    mutationFn: ({ file, id, expectedType }) =>
      apiClient
        .post(
          expand(DataObjectDescriptionVersionUrl.upload, { id }),
          {
            file,
            expectedType,
          },
          {
            headers: { 'content-type': 'multipart/form-data' },
            onUploadProgress: (progress) => {
              if (!progress.total) {
                return;
              }
              onProgress?.((progress.loaded / progress.total) * 100);
            },
          },
        )
        .then((response) => DataObjectFormDataSchema.parse(response.data)),
  });
